<template>
  <v-container>
    <v-layout column>
      <v-flex>
        <v-img alt="Uploaded image" :src="imageSrc" :max-width="width" :max-height="height" />
      </v-flex>
      <v-flex>
        <input @change="processImage" type="file" name="photo" accept="image/*" class="mt-3" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import image from '../../../api/images';

export default {
  name: 'image-upload',
  props: ['path', 'url', 'width', 'height'],
  data: () => ({
    hasFile: false
  }),
  computed: {
    imageSrc: {
      get() {
        if (this.url) {
          return this.url;
        }

        if (this.width && this.height) {
          return `https://placehold.it/${this.width}/${this.height}`;
        }

        return null;
      },

      set(url) {
        console.log(url);
        this.$emit('update:url', url);
      }
    }
  },
  methods: {
    processImage: function(element) {
      const files = element.target.files;
      if (!files[0]) {
        return;
      }

      this.hasFile = true;

      image.upload(files, this.path).then(response => {
        this.imageSrc = response.url;
      });
    }
  }
};
</script>

<style scoped>
img {
  width: 100%;
}
</style>
